import React, { useState, createContext, useContext } from 'react'

import styles from './snackbark.module.css'

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import InfoIcon from '@mui/icons-material/Info'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import CloseIcon from '@mui/icons-material/Close'

import { uuidv4 } from '../../util/hash'

const SnackbarItem = ({ variant = "error", title, description, onClose }) => {
    const icon = ({
        [variant]: <></>,
        "success": <CheckCircleOutlineIcon style={{ color: "var(--text-primary)" }} />,
        "info": <InfoIcon style={{ color: "var(--text-primary)" }} />,
        "warning": <WarningAmberIcon style={{ color: "var(--text-primary)" }} />,
        "error": <ErrorOutlineIcon style={{ color: "rgb(181, 19, 19)" }} />,
    })[variant]

    return (
        <div className={styles.snackbar}>
            <div onClick={onClose} className={styles.snackbarClose}>
                <CloseIcon style={{ fontSize: 15, color: `var(--text-primary)`}}/>
            </div>
            <div className={styles.snackbarIcon}>
                {icon}
            </div>
            <div className={styles.info}>
                <div className={styles.infoText}>{title}</div>
                <div className={styles.infoDescription}>{description}</div>
            </div>
        </div>
    )
}

const snackbarContext = createContext({
    items: [],
    addItem: () => { },
})

export const useSnackbar = () => {
    const ctx = useContext(snackbarContext)

    return {
        /*
            options = {
                variant: "success", "warning", "info", "error"
                description: ""
            }
        */
        enqueueSnackbar: (title, options) => {
            ctx.addItem(title, options)
        }
    }
}

export default ({children}) => {
    const [items, setItems] = useState([])

    const addItem = (title, { variant, description }) => { 
        const id = uuidv4()       
        const newItem = { title, variant, description, id }
        setItems(prev => [...prev, newItem])
        setTimeout(() => {
            setItems(prev => prev.filter(item => item.id !== id))
        }, 3000)
    }

    const onClose = (id) => {
        setItems(prev => prev.filter(item => item.id !== id))
    }

    return (
        <snackbarContext.Provider value={{ items, addItem }}>
            <div className={styles.snackbarContainer}>
                {
                    items.map(x => (
                        <SnackbarItem onClose={() => onClose(x?.id)} key={x?.id} {...x} />
                    ))
                }
            </div>
            {children}
        </snackbarContext.Provider>
    )
}